export const tooltipMessages = [
    "メールアドレスを変更しました。",  // 0
    "メールアドレスを入力してください。",  // 1
    "正しいメールアドレスを入力してください。",  // 2
    "変更をキャンセルしました。",  // 3
    "通知先のメールアドレスを更新しました。",  // 4
    "チェック対象外URLパターンを更新しました",  // 5
    "パターンを入力してください。",  // 6
    "ルール名称を入力してください。",  // 7
]